import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Input } from '@/shared/components/ui/input'
import { Label } from '@/shared/components/ui/label'

export interface NumericInput {
  value: string
  onChange: (v: string) => void
  onBlur: () => void
  onStep: (delta: number) => void
}

export function SettingGroup({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="mb-6">
      <h3 className="text-lg text-muted-foreground mb-1">
        {label}
      </h3>
      {children}
    </div>
  )
}

export function SettingRow({
  label,
  description,
  children,
}: {
  label: React.ReactNode
  description?: string
  children: React.ReactNode
}) {
  return (
    <div className="flex items-center justify-between gap-4 py-5 border-b border-border/40 last:border-b-0">
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <Label className="text-sm font-medium font-sans text-foreground">{label}</Label>
        {description && (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  )
}

export function StepInput({ value, onChange, onBlur, onStep }: NumericInput) {
  return (
    <div className="flex gap-1">
      <Input
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === 'Enter') (e.target as HTMLInputElement).blur()
        }}
        className="w-20 text-foreground bg-card border-border"
      />
      <div className="flex flex-col gap-0.5">
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={() => onStep(1)}
          className="h-[18px] w-7 p-0 text-foreground bg-card border-border hover:bg-muted"
          tabIndex={-1}
        >
          <ChevronUp className="h-3 w-3" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={() => onStep(-1)}
          className="h-[18px] w-7 p-0 text-foreground bg-card border-border hover:bg-muted"
          tabIndex={-1}
        >
          <ChevronDown className="h-3 w-3" />
        </Button>
      </div>
    </div>
  )
}
